import React from 'react';

export const LosArtesanos = () => {
  const artesanos = [
    {
      name: 'Juan José Bermúdez',
      role: 'Maestro Alfarero',
      description: 'Aprendió el oficio a los doce años junto a su tía Emma Bermúdez, figura central de la alfarería de El Cercado durante décadas. Hoy es su heredero más activo y el mayor guardián de la tradición.',
      image: '/images/artesano_carlos.jpg'
    },
    {
      name: 'Familia Domínguez',
      role: 'Artesanos',
      description: 'Camila, Carmen Elena, Claudia, María Concepción, María de Jesús, Petronila. Los apellidos se repiten porque el oficio se hereda. El corazón artesanal de El Cercado.',
      image: 'https://images.unsplash.com/photo-1652898090487-b75769da25f3'
    },
    {
      name: 'Generación Joven',
      role: 'Aprendices',
      description: 'Los herederos del fuego. Jóvenes de El Cercado que aprenden el rodete junto a los maestros, asegurando que la tradición siga viva otros quinientos años.',
      image: 'https://images.unsplash.com/photo-1723934602376-901870979337'
    }
  ];

  return (
    <section id="los-artesanos" className="section-padding bg-background">
      <div className="editorial-container">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="nav-label text-siena">Los Artesanos</span>
          <h2 className="display-heading text-4xl md:text-5xl lg:text-6xl text-earth mt-4 mb-6">
            Las manos que
            <br />
            <span className="text-ochre">dan forma al legado</span>
          </h2>
          <p className="body-text text-lg">
            Detrás de cada pieza hay una historia personal, una familia, un linaje. Estos son los artesanos que mantienen viva la llama de El Cercado.
          </p>
        </div>

        {/* Artisan Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {artesanos.map((artesano, index) => (
            <div
              key={index}
              className="group bg-cal-darker rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
            >
              {/* Image */}
              <div className="relative h-80 overflow-hidden">
                <img
                  src={artesano.image}
                  alt={artesano.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  style={{ 
                    objectPosition: artesano.name === 'Juan José Bermúdez' 
                      ? 'center 65%' 
                      : 'center center' 
                  }}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-earth/60 to-transparent" />
              </div>

              {/* Content */}
              <div className="p-8">
                <p className="text-sm text-siena uppercase tracking-wider font-medium mb-2">
                  {artesano.role}
                </p>
                <h3 className="display-heading text-3xl text-earth mb-4">
                  {artesano.name}
                </h3>
                <p className="body-text text-base leading-relaxed">
                  {artesano.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Family Tree Visual */}
        <div className="mt-20 text-center">
          <div className="inline-flex items-center gap-4 px-8 py-4 bg-siena/10 rounded-full">
            <div className="w-3 h-3 rounded-full bg-siena animate-pulse" />
            <p className="text-earth font-medium">
              Familia Domínguez · 6 generaciones · 500+ años de tradición
            </p>
            <div className="w-3 h-3 rounded-full bg-ochre animate-pulse" />
          </div>
        </div>
      </div>
    </section>
  );
};
